import styled from 'styled-components';
import { TypographyStyles, colours, media, spacing } from '@storefront/lib-global/stylings';

export const StyledMeasurementList = styled.ul<{ $isOneSizeProduct?: boolean }>`
  display: grid;
  grid-gap: ${spacing.XXXS};
  grid-template-columns: ${({ $isOneSizeProduct }) => ($isOneSizeProduct ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)')};
  margin: 0;
  padding: 0;

  @media ${media.greaterThan('lg')} {
    grid-template-columns: ${({ $isOneSizeProduct }) => ($isOneSizeProduct ? 'repeat(4, 1fr)' : 'repeat(6, 1fr)')};
    max-width: 523px;
  }
`;
export const StyledMeasurementListItem = styled.li<{ $isTwoSpaces?: boolean }>`
  grid-column: ${({ $isTwoSpaces }) => ($isTwoSpaces ? 'span 2' : 'initial')};
  min-width: 100%;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: fit-content;
`;
export const StyledMeasurementBlock = styled.button`
  ${TypographyStyles.Body.Small.Medium}
  align-items: center;
  background-color: inherit;
  border: 1px solid ${colours.GREY};
  color: ${colours.BLACK};
  display: flex;
  gap: 4px;
  height: 100%;
  justify-content: center;
  line-height: 20px;
  min-height: 32px;
  text-align: center;
  text-decoration: none;
  white-space: normal;
  width: 100%;
  word-break: break-word;

  &.active {
    background-color: ${colours.LIGHT_BLUE};
    border: 1px solid ${colours.NAVY_BLUE};
    ${TypographyStyles.Body.Small.SemiBold}
    @media ${media.greaterThan('lg')} {
      font-size: 14px;
    }
  }

  &.crossed {
    align-items: center;
    color: ${colours.GREY};
    display: flex;
    justify-content: center;
    padding: 1px;

    &.active {
      color: ${colours.BLACK};
    }
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:visited {
    color: ${colours.BLACK};
  }

  &:not(.active):hover,
  &:not(.active):focus {
    background-color: ${colours.LIGHT_BLUE};
    border: 1px solid ${colours.NAVY_BLUE};
  }
  @media ${media.greaterThan('lg')} {
    font-size: 14px;
  }
`;
